import api from "services/api";
import { getAffiliateToken } from "utils/affiliateAttribution";
import { sanitizeTextInput } from "utils/profileValidation";

/**
 * Email OTP auth for streamlined login/register.
 *
 * Expected API contract (backend):
 * POST /request-login-otp  → { email, bonusOffer?, referralCode?, language?, affiliateToken? }
 * POST /verify-login-otp   → { email, otp_code } → same shape as POST /login on success
 * POST /resend-login-otp   → { email }
 */
export function buildLoginOtpPayload({
  email,
  bonusOffer,
  referralCode,
  language,
  ageConfirmation,
  agreeToTerms,
}) {
  const payload = {
    email: sanitizeTextInput(email, 250).toLowerCase(),
    language,
  };

  // Legal consent captured at the account-creation step (mirrors /quick-signup).
  if (ageConfirmation !== undefined) {
    payload.ageConfirmation = ageConfirmation ? 1 : 0;
  }
  if (agreeToTerms !== undefined) {
    payload.agreeToTerms = agreeToTerms ? 1 : 0;
  }

  if (bonusOffer) {
    payload.bonusOffer = bonusOffer;
  }

  const sanitizedReferral = sanitizeTextInput(referralCode, 80);
  if (sanitizedReferral) {
    payload.referralCode = sanitizedReferral;
  }

  const affToken = getAffiliateToken();
  if (affToken) {
    payload.affiliateToken = affToken;
  }

  return payload;
}

export function requestLoginOtp(payload) {
  return api.post("/request-login-otp", payload);
}

export function verifyLoginOtp(email, otpCode, bonusOffer) {
  const payload = {
    email: sanitizeTextInput(email, 250).toLowerCase(),
    otp_code: String(otpCode || "").trim(),
  };
  // Passwordless bonus is chosen on the code-entry screen and applied on lazy
  // signup; backend ignores it for existing accounts and non-offered bonuses.
  if (bonusOffer) {
    payload.bonusOffer = bonusOffer;
  }
  return api.post("/verify-login-otp", payload);
}

export function resendLoginOtp(email) {
  return api.post("/resend-login-otp", {
    email: sanitizeTextInput(email, 250).toLowerCase(),
  });
}
